import { render, staticRenderFns } from "./secondhand_new.vue?vue&type=template&id=0897c125&"
import script from "./secondhand_new.vue?vue&type=script&lang=js&"
export * from "./secondhand_new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports